/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TreeNode from "./TreeNode.vue";

const __vue_script__ = {
	name: "FileBrowser",
	components: {
		TreeNode,
	},
	data() {
		return {
			node: {
				label: __("Home"),
				value: "Home",
				children: [],
				children_start: 0,
				children_loading: false,
				is_leaf: false,
				fetching: false,
				fetched: false,
				open: false,
				filtered: true,
			},
			selected_node: {},
			search_text: "",
			page_length: 10,
		};
	},
	mounted() {
		this.toggle_node(this.node);
	},
	methods: {
		toggle_node(node) {
			if (!node.fetched && !node.is_leaf) {
				node.fetching = true;
				node.children_start = 0;
				node.children_loading = false;
				this.get_files_in_folder(node.value, 0).then(({ files, has_more }) => {
					node.open = true;
					node.children = files;
					node.fetched = true;
					node.fetching = false;
					node.children_start += this.page_length;
					node.has_more_children = has_more;
				});
			} else {
				node.open = !node.open;
				this.select_node(node);
			}
		},
		load_more(node) {
			if (node.has_more_children) {
				let start = node.children_start;
				node.children_loading = true;
				this.get_files_in_folder(node.value, start).then(({ files, has_more }) => {
					node.children = node.children.concat(files);
					node.children_start += this.page_length;
					node.has_more_children = has_more;
					node.children_loading = false;
				});
			}
		},
		select_node(node) {
			if (node.is_leaf) {
				this.selected_node = node;
			}
		},
		get_files_in_folder(folder, start) {
			return frappe
				.call("frappe.core.api.file.get_files_in_folder", {
					folder,
					start,
					page_length: this.page_length,
				})
				.then((r) => {
					let { files = [], has_more = false } = r.message || {};
					files.sort((a, b) => {
						if (a.is_folder && b.is_folder) {
							return a.modified < b.modified ? -1 : 1;
						}
						if (a.is_folder) {
							return -1;
						}
						if (b.is_folder) {
							return 1;
						}
						return 0;
					});
					files = files.map((file) => this.make_file_node(file));
					return { files, has_more };
				});
		},
		search_by_name: frappe.utils.debounce(function () {
			if (this.search_text === "") {
				this.node = this.folder_node;
				return;
			}
			if (this.search_text.length < 3) return;
			frappe
				.call("frappe.core.api.file.get_files_by_search_text", {
					text: this.search_text,
				})
				.then((r) => {
					let files = r.message || [];
					files = files.map((file) => this.make_file_node(file));
					if (!this.folder_node) {
						this.folder_node = this.node;
					}
					this.node = {
						label: __("Search Results"),
						value: "",
						children: files,
						by_search: true,
						open: true,
						filtered: true,
					};
				});
		}, 300),
		make_file_node(file) {
			let filename = file.file_name || file.name;
			let label = frappe.utils.file_name_ellipsis(filename, 40);
			return {
				label: label,
				filename: filename,
				file_url: file.file_url,
				value: file.name,
				is_leaf: !file.is_folder,
				fetched: !file.is_folder, // fetched if node is leaf
				children: [],
				children_loading: false,
				children_start: 0,
				open: false,
				fetching: false,
				filtered: true,
			};
		},
	},
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-browser" }, [
    _c("div", [
      _c(
        "a",
        {
          staticClass: "text-muted text-medium",
          attrs: { href: "" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("hide-browser")
            },
          },
        },
        [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.__("← Back to upload files")) + "\n\t\t"
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "file-browser-list" },
      [
        _c("div", { staticClass: "file-filter" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search_text,
                expression: "search_text",
              },
            ],
            staticClass: "form-control input-xs",
            attrs: {
              type: "search",
              placeholder: _vm.__("Search by filename or extension"),
            },
            domProps: { value: _vm.search_text },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search_text = $event.target.value
                },
                _vm.search_by_name,
              ],
            },
          }),
        ]),
        _vm._v(" "),
        _c("TreeNode", {
          staticClass: "tree with-skeleton",
          attrs: { node: _vm.node, selected_node: _vm.selected_node },
          on: {
            "node-click": function (n) {
              return _vm.toggle_node(n)
            },
            "load-more": function (n) {
              return _vm.load_more(n)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1183ad38_0", { source: "\n.file-browser-list {\n\theight: 300px;\n\toverflow: hidden;\n\tmargin-top: 10px;\n}\n.file-filter {\n\tpadding: 3px;\n}\n.tree {\n\toverflow: auto;\n\theight: 100%;\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tpadding-bottom: 4rem;\n}\n", map: {"version":3,"sources":["frappe/public/js/frappe/file_uploader/FileBrowser.vue"],"names":[],"mappings":";AAuKA;CACA,aAAA;CACA,gBAAA;CACA,gBAAA;AACA;AAEA;CACA,YAAA;AACA;AAEA;CACA,cAAA;CACA,YAAA;CACA,eAAA;CACA,gBAAA;CACA,oBAAA;AACA","file":"FileBrowser.vue","sourcesContent":["<template>\n\t<div class=\"file-browser\">\n\t\t<div>\n\t\t\t<a href=\"\" class=\"text-muted text-medium\" @click.prevent=\"$emit('hide-browser')\">\n\t\t\t\t{{ __(\"← Back to upload files\") }}\n\t\t\t</a>\n\t\t</div>\n\t\t<div class=\"file-browser-list\">\n\t\t\t<div class=\"file-filter\">\n\t\t\t\t<input\n\t\t\t\t\ttype=\"search\"\n\t\t\t\t\tclass=\"form-control input-xs\"\n\t\t\t\t\t:placeholder=\"__('Search by filename or extension')\"\n\t\t\t\t\tv-model=\"search_text\"\n\t\t\t\t\t@input=\"search_by_name\"\n\t\t\t\t/>\n\t\t\t</div>\n\t\t\t<TreeNode\n\t\t\t\tclass=\"tree with-skeleton\"\n\t\t\t\t:node=\"node\"\n\t\t\t\t:selected_node=\"selected_node\"\n\t\t\t\t@node-click=\"(n) => toggle_node(n)\"\n\t\t\t\t@load-more=\"(n) => load_more(n)\"\n\t\t\t/>\n\t\t</div>\n\t</div>\n</template>\n<script>\nimport TreeNode from \"./TreeNode.vue\";\n\nexport default {\n\tname: \"FileBrowser\",\n\tcomponents: {\n\t\tTreeNode,\n\t},\n\tdata() {\n\t\treturn {\n\t\t\tnode: {\n\t\t\t\tlabel: __(\"Home\"),\n\t\t\t\tvalue: \"Home\",\n\t\t\t\tchildren: [],\n\t\t\t\tchildren_start: 0,\n\t\t\t\tchildren_loading: false,\n\t\t\t\tis_leaf: false,\n\t\t\t\tfetching: false,\n\t\t\t\tfetched: false,\n\t\t\t\topen: false,\n\t\t\t\tfiltered: true,\n\t\t\t},\n\t\t\tselected_node: {},\n\t\t\tsearch_text: \"\",\n\t\t\tpage_length: 10,\n\t\t};\n\t},\n\tmounted() {\n\t\tthis.toggle_node(this.node);\n\t},\n\tmethods: {\n\t\ttoggle_node(node) {\n\t\t\tif (!node.fetched && !node.is_leaf) {\n\t\t\t\tnode.fetching = true;\n\t\t\t\tnode.children_start = 0;\n\t\t\t\tnode.children_loading = false;\n\t\t\t\tthis.get_files_in_folder(node.value, 0).then(({ files, has_more }) => {\n\t\t\t\t\tnode.open = true;\n\t\t\t\t\tnode.children = files;\n\t\t\t\t\tnode.fetched = true;\n\t\t\t\t\tnode.fetching = false;\n\t\t\t\t\tnode.children_start += this.page_length;\n\t\t\t\t\tnode.has_more_children = has_more;\n\t\t\t\t});\n\t\t\t} else {\n\t\t\t\tnode.open = !node.open;\n\t\t\t\tthis.select_node(node);\n\t\t\t}\n\t\t},\n\t\tload_more(node) {\n\t\t\tif (node.has_more_children) {\n\t\t\t\tlet start = node.children_start;\n\t\t\t\tnode.children_loading = true;\n\t\t\t\tthis.get_files_in_folder(node.value, start).then(({ files, has_more }) => {\n\t\t\t\t\tnode.children = node.children.concat(files);\n\t\t\t\t\tnode.children_start += this.page_length;\n\t\t\t\t\tnode.has_more_children = has_more;\n\t\t\t\t\tnode.children_loading = false;\n\t\t\t\t});\n\t\t\t}\n\t\t},\n\t\tselect_node(node) {\n\t\t\tif (node.is_leaf) {\n\t\t\t\tthis.selected_node = node;\n\t\t\t}\n\t\t},\n\t\tget_files_in_folder(folder, start) {\n\t\t\treturn frappe\n\t\t\t\t.call(\"frappe.core.api.file.get_files_in_folder\", {\n\t\t\t\t\tfolder,\n\t\t\t\t\tstart,\n\t\t\t\t\tpage_length: this.page_length,\n\t\t\t\t})\n\t\t\t\t.then((r) => {\n\t\t\t\t\tlet { files = [], has_more = false } = r.message || {};\n\t\t\t\t\tfiles.sort((a, b) => {\n\t\t\t\t\t\tif (a.is_folder && b.is_folder) {\n\t\t\t\t\t\t\treturn a.modified < b.modified ? -1 : 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tif (a.is_folder) {\n\t\t\t\t\t\t\treturn -1;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tif (b.is_folder) {\n\t\t\t\t\t\t\treturn 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t\treturn 0;\n\t\t\t\t\t});\n\t\t\t\t\tfiles = files.map((file) => this.make_file_node(file));\n\t\t\t\t\treturn { files, has_more };\n\t\t\t\t});\n\t\t},\n\t\tsearch_by_name: frappe.utils.debounce(function () {\n\t\t\tif (this.search_text === \"\") {\n\t\t\t\tthis.node = this.folder_node;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\tif (this.search_text.length < 3) return;\n\t\t\tfrappe\n\t\t\t\t.call(\"frappe.core.api.file.get_files_by_search_text\", {\n\t\t\t\t\ttext: this.search_text,\n\t\t\t\t})\n\t\t\t\t.then((r) => {\n\t\t\t\t\tlet files = r.message || [];\n\t\t\t\t\tfiles = files.map((file) => this.make_file_node(file));\n\t\t\t\t\tif (!this.folder_node) {\n\t\t\t\t\t\tthis.folder_node = this.node;\n\t\t\t\t\t}\n\t\t\t\t\tthis.node = {\n\t\t\t\t\t\tlabel: __(\"Search Results\"),\n\t\t\t\t\t\tvalue: \"\",\n\t\t\t\t\t\tchildren: files,\n\t\t\t\t\t\tby_search: true,\n\t\t\t\t\t\topen: true,\n\t\t\t\t\t\tfiltered: true,\n\t\t\t\t\t};\n\t\t\t\t});\n\t\t}, 300),\n\t\tmake_file_node(file) {\n\t\t\tlet filename = file.file_name || file.name;\n\t\t\tlet label = frappe.utils.file_name_ellipsis(filename, 40);\n\t\t\treturn {\n\t\t\t\tlabel: label,\n\t\t\t\tfilename: filename,\n\t\t\t\tfile_url: file.file_url,\n\t\t\t\tvalue: file.name,\n\t\t\t\tis_leaf: !file.is_folder,\n\t\t\t\tfetched: !file.is_folder, // fetched if node is leaf\n\t\t\t\tchildren: [],\n\t\t\t\tchildren_loading: false,\n\t\t\t\tchildren_start: 0,\n\t\t\t\topen: false,\n\t\t\t\tfetching: false,\n\t\t\t\tfiltered: true,\n\t\t\t};\n\t\t},\n\t},\n};\n</script>\n\n<style>\n.file-browser-list {\n\theight: 300px;\n\toverflow: hidden;\n\tmargin-top: 10px;\n}\n\n.file-filter {\n\tpadding: 3px;\n}\n\n.tree {\n\toverflow: auto;\n\theight: 100%;\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tpadding-bottom: 4rem;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frappe/public/js/frappe/file_uploader/FileBrowser.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__